import httpAuth from "../../services/httpAuth";
// import jwt from 'jsonwebtoken'
import getErrorMessage from "../../helpers/getErrorMessage.helper";
import {
  setMarket,
  setMarketType,
  setRunner,
  setIsBack,
  setPrice,
  setDelay,
  setStake,
  setMaxBet,
  setMaxWinPerMarket,
  setMtype,
  setMinBet,
  setEventTypeId,
  setEventId,
  setCompetitionId,
  setPriceActual,
  setMinMaxAll,
  setIsConfirmBetPopUpOpen,
  setBetDelay,
  setMarketName,
  setRunnerName,
  setEventName,
  setIsCashOut,
  setStartTime,
  setBetPlacingPopoverStage,
} from "./betPlacing.slice";
import { getAuthSuccess } from "../auth/auth.slice";
import { setAuthDataSuccess } from "../auth/authData.slice";
import { ID_TOKEN, TOKEN_EXP } from "../../config/app.config";
import { setScrollPosition } from "../elementsParams/elementsParams.slice";

import { profitCalculate } from "../../helpers/profitCalculate";

export const requestBetDelay = () => async (dispatch, getState) => {
  const auth = getState().auth;

  const staticBetDelay = {
    matchoddsBetDelay: 5,
    soccerBetDelay: 5,
    tennisBetDelay: 5,
    bookmakerBetDelay: 5,
    fancyBetDelay: 5,
    ballbyballBetDelay: 5,
    virtualBetDelay: 5,
  };

  const staticMinMax = {
    fancyMinLimit: "1",
    fancyMaxLimit: "100000",
    oddsMinLimit: "1",
    oddsMaxLimit: "100000",
    bookmakerMinLimit: "100",
    bookmakerMaxLimit: "2000000",
    sfancyMinLimit: "100",
    sfancyMaxLimit: "50000",
    soddsMinLimit: "100",
    soddsMaxLimit: "50000",
    sbookmakerMinLimit: "100",
    sbookmakerMaxLimit: "50000",
    tfancyMinLimit: "100",
    tfancyMaxLimit: "50000",
    toddsMinLimit: "100",
    toddsMaxLimit: "50000",
    tbookmakerMinLimit: "100",
    tbookmakerMaxLimit: "50000",
  };

  if (auth) {
    try {
      const response = await httpAuth.post("getUserSetting", {
        headers: {
          authorization: `Bearer ${auth}`,
        },
      });

      if (response.status == 200 && response?.data?.success) {
        dispatch(
          setBetDelay({
            matchoddsBetDelay: response?.data?.data?.oddsBetDelay,
            soccerBetDelay: response?.data?.data?.soccerBetDelay,
            tennisBetDelay: response?.data?.data?.tennisBetDelay,
            bookmakerBetDelay: response?.data?.data?.bookmakerBetDelay,
            fancyBetDelay: response?.data?.data?.fancyBetDelay,
            ballbyballBetDelay: response?.data?.data?.ballbyballBetDelay,
            virtualBetDelay: response?.data?.data?.virtualBetDelay,
          }),
        );

        dispatch(
          setMinMaxAll({
            fancyMinLimit: response?.data?.data?.fancyMinLimit,
            fancyMaxLimit: response?.data?.data?.fancyMaxLimit,
            oddsMinLimit: response?.data?.data?.oddsMinLimit,
            oddsMaxLimit: response?.data?.data?.oddsMaxLimit,
            bookmakerMinLimit: response?.data?.data?.bookmakerMinLimit,
            bookmakerMaxLimit: response?.data?.data?.bookmakerMaxLimit,
            sfancyMinLimit: response?.data?.data?.sfancyMinLimit,
            sfancyMaxLimit: response?.data?.data?.sfancyMaxLimit,
            soddsMinLimit: response?.data?.data?.soddsMinLimit,
            soddsMaxLimit: response?.data?.data?.soddsMaxLimit,
            sbookmakerMinLimit: response?.data?.data?.sbookmakerMinLimit,
            sbookmakerMaxLimit: response?.data?.data?.sbookmakerMaxLimit,
            tfancyMinLimit: response?.data?.data?.tfancyMinLimit,
            tfancyMaxLimit: response?.data?.data?.tfancyMaxLimit,
            toddsMinLimit: response?.data?.data?.toddsMinLimit,
            toddsMaxLimit: response?.data?.data?.toddsMaxLimit,
            tbookmakerMinLimit: response?.data?.data?.tbookmakerMinLimit,
            tbookmakerMaxLimit: response?.data?.data?.tbookmakerMaxLimit,
          }),
        );
      } else {
        dispatch(setBetDelay(staticBetDelay));
        dispatch(setMinMaxAll(staticMinMax));
      }
    } catch (e) {
      dispatch(setBetDelay(staticBetDelay));
      dispatch(setMinMaxAll(staticMinMax));
    }
  } else {
    dispatch(setBetDelay(staticBetDelay));
    dispatch(setMinMaxAll(staticMinMax));
  }
};

export const requestBetPlacingStart =
  (marketId, runnerId, setAll = false) =>
  async (dispatch, getState) => {
    //Calling this on openBetslip to get settings
    const auth = getState().auth;
    // if(auth) {
    //   try {
    //     const response = await httpAuth.post('/exchange/order/settings/',  { marketId, runnerId })
    //     // if ( setAll && response.data.result) {
    //     //   dispatch(setMinMaxAll({
    //     //     maxBet: response.data.result.maxBet,
    //     //     maxWinPerMarket: response.data.result.maxWinPerMarket,
    //     //     marketId: response.data.result.marketId
    //     //   }))
    //     //   return
    //     // }
    //     if (setAll) {return response}
    //     if (response.data.result) {
    //       dispatch(setMaxBet(response.data.result.maxBet))
    //       dispatch(setMaxWinPerMarket(response.data.result.maxWinPerMarket))
    //       dispatch(setMtype(response.data.result.mType))
    //       dispatch(setMinBet(response.data.result.minBet))
    //       dispatch(setEventTypeId(response.data.result.eventTypeId))
    //       dispatch(setEventId(response.data.result.eventId))
    //       dispatch(setCompetitionId(response.data.result.competitionId))
    //     }
    //   } catch (e) {
    //     dispatch(setMarket(null))
    //     dispatch(setRunner(null))
    //     dispatch(setIsBack(null))
    //     dispatch(setPrice(null))
    //     dispatch(setPriceActual(null))
    //     dispatch(setDelay(null))
    //     dispatch(setStake(null))
    //     // const errorMsg = getErrorMessage(e)
    //     // throw errorMsg;
    //   }
    // } else {
    //   console.log("not auth so betSettings not called")
    // }
  };

export const requestSetOrder = (betPlacing) => async (dispatch, getState) => {
  const data = {
    is_back: betPlacing.isBack ? 1 : 0,
    market_id: betPlacing.market,
    odds: betPlacing.priceActual,
    selection_id: betPlacing.runner,
    stack: Number(betPlacing.stake),
  };

  try {
    const response = await httpAuth.post(
      "/bet/saveBet",

      data,
    );
    if (response.headers["authorization"]) {
      const decoded = jwt.decode(response.headers["authorization"], {
        complete: true,
      });
      dispatch(getAuthSuccess(response.headers["authorization"]));

      dispatch(setAuthDataSuccess(decoded));
      localStorage.setItem(ID_TOKEN, response.headers["authorization"]);
      localStorage.setItem(TOKEN_EXP, decoded.payload.exp);
    }
    dispatch(setMarket(null));
    dispatch(setRunner(null));
    dispatch(setPrice(null));
    dispatch(setPriceActual(null));
    dispatch(setDelay(null));
    dispatch(setStake(null));
    return response;
  } catch (e) {
    dispatch(setMarket(null));
    dispatch(setRunner(null));
    dispatch(setPrice(null));
    dispatch(setPriceActual(null));
    dispatch(setDelay(null));
    dispatch(setStake(null));
    const errorMsg = getErrorMessage(e);
    throw errorMsg;
  }
};
export const requestSetFancyOrder =
  (betPlacing) => async (dispatch, getState) => {
    const data = {
      is_back: betPlacing.isBack ? 1 : 0,
      // betPlacing?.marketAll?.category == 6
      //   ? betPlacing.isBack
      //     ? 0
      //     : 1
      //   : betPlacing.isBack
      //     ? 1
      //     : 0,
      fancy_id: betPlacing.market,
      run: betPlacing.priceActual,
      size: betPlacing.runner,
      stack: Number(betPlacing.stake),
    };

    try {
      const response = await httpAuth.post(
        "/bet/saveFancyBet",
        // [
        //   {
        //     side: betPlacing.isBack ? 0 : 1,
        //     price: betPlacing.priceActual,
        //     selectionId: betPlacing.runner,
        //     btype: betPlacing.btype,
        //     oddsType: betPlacing.oddsType,
        //     eventTypeId: betPlacing.eventTypeId,
        //     marketId: betPlacing.market,
        //     totalSize: Number(betPlacing.stake),
        //     betSlipRef: betPlacing.betSlipRef,
        //     fromOneClick: betPlacing.fromOneClick ? 1 : 0,
        //     betDelay: betPlacing.delay,
        //     line: betPlacing.line,
        //   }
        // ]
        data,
        // {
        //   headers: {
        //     'x-user-id': getState().user.memberCode,
        //     // temporary hard-coded
        //     'x-app-version': '4.0.19.2',
        //     'x-client': 'mobile',
        //     'x-client-id': '451012928.1605029998',
        //     'x-client-info': 'e883e9a15db99de2fdd0579c576a0693',
        //     'x-log-timing': true,
        //     'x-xid': '6b76ff17-70d2-b5fe-2373-08f62ee312af',
        //   }
        // }
      );
      if (response.headers["authorization"]) {
        const decoded = jwt.decode(response.headers["authorization"], {
          complete: true,
        });
        dispatch(getAuthSuccess(response.headers["authorization"]));

        dispatch(setAuthDataSuccess(decoded));
        localStorage.setItem(ID_TOKEN, response.headers["authorization"]);
        localStorage.setItem(TOKEN_EXP, decoded.payload.exp);
      }
      dispatch(setMarket(null));
      dispatch(setRunner(null));
      dispatch(setPrice(null));
      dispatch(setPriceActual(null));
      dispatch(setDelay(null));
      dispatch(setStake(null));
      return response;
    } catch (e) {
      dispatch(setMarket(null));
      dispatch(setRunner(null));
      dispatch(setPrice(null));
      dispatch(setPriceActual(null));
      dispatch(setDelay(null));
      dispatch(setStake(null));
      const errorMsg = getErrorMessage(e);
      throw errorMsg;
    }
  };

export const requestCashOut = (marketId) => async (dispatch, getState) => {
  try {
    const response = await httpAuth.get(
      `/exchange/order/cashout?marketId=${marketId}`,
      {
        headers: {
          "x-app-version": "4.0.19.2",
          "x-client": "mobile",
          "x-client-id": "451012928.1605029998",
          "x-client-info": "e883e9a15db99de2fdd0579c576a0693",
          "x-log-timing": true,
          "x-xid": "6b76ff17-70d2-b5fe-2373-08f62ee312af",
        },
      },
    );
    if (response.data.success) {
      // dispatch(getSportLadderSuccess(response.data.result))
      if (response.headers["authorization"]) {
        const decoded = jwt.decode(response.headers["authorization"], {
          complete: true,
        });
        dispatch(getAuthSuccess(response.headers["authorization"]));

        dispatch(setAuthDataSuccess(decoded));
        localStorage.setItem(ID_TOKEN, response.headers["authorization"]);
        localStorage.setItem(TOKEN_EXP, decoded.payload.exp);
      }
    }
    return response;
  } catch (e) {
    const errorMsg = getErrorMessage(e);
    throw errorMsg;
    // dispatch(getSportLadderError())
  }
};

export const requestCancelOrder = (orderId) => async (dispatch) => {
  let data = { bet_id: orderId };
  try {
    const response = await httpAuth.post(`/bet/cancelUnmatchedBet`, data);
    return response;
  } catch (e) {
    const errorMsg = getErrorMessage(e);
    throw errorMsg;
  }
};

export const requestCancelAllBets = (marketId) => async (dispatch) => {
  let data = { market_id: marketId };
  try {
    const response = await httpAuth.post(`/bet/cancelUnmatchedBetAll`, data);
    return response;
  } catch (e) {
    const errorMsg = getErrorMessage(e);
    throw errorMsg;
  }
};

//
export const isConfirmBetPopUpOpenThunk = (open) => async (dispatch) => {
  if (open) {
    dispatch(setIsConfirmBetPopUpOpen(open));
  }
  if (!open) {
    dispatch(setIsConfirmBetPopUpOpen(false));
  }
};
//

export const requestHROrder = (data) => async (dispatch, getState) => {
  try {
    const response = await httpAuth.post("/bet/saveHrBet", data);
    if (response.headers["authorization"]) {
      const decoded = jwt.decode(response.headers["authorization"], {
        complete: true,
      });
      dispatch(getAuthSuccess(response.headers["authorization"]));

      dispatch(setAuthDataSuccess(decoded));
      localStorage.setItem(ID_TOKEN, response.headers["authorization"]);
      localStorage.setItem(TOKEN_EXP, decoded.payload.exp);
    }
    dispatch(setMarket(null));
    dispatch(setRunner(null));
    dispatch(setPrice(null));
    dispatch(setPriceActual(null));
    dispatch(setDelay(null));
    dispatch(setStake(null));
    return response;
  } catch (e) {
    dispatch(setMarket(null));
    dispatch(setRunner(null));
    dispatch(setPrice(null));
    dispatch(setPriceActual(null));
    dispatch(setDelay(null));
    dispatch(setStake(null));
    const errorMsg = getErrorMessage(e);
    throw errorMsg;
  }
};
